import React from "react";
import { PopupAnimation } from "@learningblocks/storybook-components";
import * as animations from "./animation";

export default function AnimationModal(props: {
  isOpen: boolean;
  onClose: () => void;
  animation: keyof typeof animations;
  ariaLabel?: string;
  stopOnLastFrame?: boolean;
  closeOnComplete?: boolean;
  noteText?: string;
}) {
  return (
    <PopupAnimation
      key={props.animation}
      open={props.isOpen}
      label={""}
      watched={false}
      setWatched={() => true}
      onClose={props.onClose}
      animationData={animations[props.animation] || animations["osmosis"]}
      ariaLabel={props.ariaLabel}
      showControls={false}
      stopOnLastFrame={props.stopOnLastFrame}
      closeOnComplete={props.closeOnComplete}
      noteText={props.noteText}
    />
  );
}
